// Master locale registry — all languages supported by the platform
// Matches Facebook's language set (minus joke locales)

export interface LocaleEntry {
  code: string;
  name: string;       // English name
  nativeName: string; // Native script name
  rtl: boolean;
}

export const LOCALES: LocaleEntry[] = [
  { code: 'en', name: 'English', nativeName: 'English', rtl: false },
  { code: 'en-GB', name: 'English (UK)', nativeName: 'English (UK)', rtl: false },
  { code: 'af', name: 'Afrikaans', nativeName: 'Afrikaans', rtl: false },
  { code: 'am', name: 'Amharic', nativeName: 'አማርኛ', rtl: false },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', rtl: true },
  { code: 'az', name: 'Azerbaijani', nativeName: 'Azərbaycan dili', rtl: false },
  { code: 'be', name: 'Belarusian', nativeName: 'Беларуская', rtl: false },
  { code: 'bg', name: 'Bulgarian', nativeName: 'Български', rtl: false },
  { code: 'bn', name: 'Bengali', nativeName: 'বাংলা', rtl: false },
  { code: 'bs', name: 'Bosnian', nativeName: 'Bosanski', rtl: false },
  { code: 'ca', name: 'Catalan', nativeName: 'Català', rtl: false },
  { code: 'ceb', name: 'Cebuano', nativeName: 'Cebuano', rtl: false },
  { code: 'cs', name: 'Czech', nativeName: 'Čeština', rtl: false },
  { code: 'cy', name: 'Welsh', nativeName: 'Cymraeg', rtl: false },
  { code: 'da', name: 'Danish', nativeName: 'Dansk', rtl: false },
  { code: 'de', name: 'German', nativeName: 'Deutsch', rtl: false },
  { code: 'el', name: 'Greek', nativeName: 'Ελληνικά', rtl: false },
  { code: 'eo', name: 'Esperanto', nativeName: 'Esperanto', rtl: false },
  { code: 'es', name: 'Spanish', nativeName: 'Español', rtl: false },
  { code: 'es-LA', name: 'Spanish (Latin America)', nativeName: 'Español (Latinoamérica)', rtl: false },
  { code: 'et', name: 'Estonian', nativeName: 'Eesti', rtl: false },
  { code: 'eu', name: 'Basque', nativeName: 'Euskara', rtl: false },
  { code: 'fa', name: 'Persian', nativeName: 'فارسی', rtl: true },
  { code: 'fi', name: 'Finnish', nativeName: 'Suomi', rtl: false },
  { code: 'fo', name: 'Faroese', nativeName: 'Føroyskt', rtl: false },
  { code: 'fr', name: 'French', nativeName: 'Français', rtl: false },
  { code: 'fr-CA', name: 'French (Canada)', nativeName: 'Français (Canada)', rtl: false },
  { code: 'fy', name: 'Frisian', nativeName: 'Frysk', rtl: false },
  { code: 'ga', name: 'Irish', nativeName: 'Gaeilge', rtl: false },
  { code: 'gl', name: 'Galician', nativeName: 'Galego', rtl: false },
  { code: 'gn', name: 'Guarani', nativeName: "Avañe'ẽ", rtl: false },
  { code: 'gu', name: 'Gujarati', nativeName: 'ગુજરાતી', rtl: false },
  { code: 'ha', name: 'Hausa', nativeName: 'Hausa', rtl: false },
  { code: 'he', name: 'Hebrew', nativeName: 'עברית', rtl: true },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी', rtl: false },
  { code: 'hr', name: 'Croatian', nativeName: 'Hrvatski', rtl: false },
  { code: 'hu', name: 'Hungarian', nativeName: 'Magyar', rtl: false },
  { code: 'hy', name: 'Armenian', nativeName: 'Հայերեն', rtl: false },
  { code: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia', rtl: false },
  { code: 'ig', name: 'Igbo', nativeName: 'Igbo', rtl: false },
  { code: 'is', name: 'Icelandic', nativeName: 'Íslenska', rtl: false },
  { code: 'it', name: 'Italian', nativeName: 'Italiano', rtl: false },
  { code: 'ja', name: 'Japanese', nativeName: '日本語', rtl: false },
  { code: 'jv', name: 'Javanese', nativeName: 'Basa Jawa', rtl: false },
  { code: 'ka', name: 'Georgian', nativeName: 'ქართული', rtl: false },
  { code: 'kk', name: 'Kazakh', nativeName: 'Қазақ тілі', rtl: false },
  { code: 'km', name: 'Khmer', nativeName: 'ភាសាខ្មែរ', rtl: false },
  { code: 'kn', name: 'Kannada', nativeName: 'ಕನ್ನಡ', rtl: false },
  { code: 'ko', name: 'Korean', nativeName: '한국어', rtl: false },
  { code: 'ku', name: 'Kurdish', nativeName: 'Kurdî', rtl: true },
  { code: 'ky', name: 'Kyrgyz', nativeName: 'Кыргызча', rtl: false },
  { code: 'la', name: 'Latin', nativeName: 'Latina', rtl: false },
  { code: 'lo', name: 'Lao', nativeName: 'ພາສາລາວ', rtl: false },
  { code: 'lt', name: 'Lithuanian', nativeName: 'Lietuvių', rtl: false },
  { code: 'lv', name: 'Latvian', nativeName: 'Latviešu', rtl: false },
  { code: 'mg', name: 'Malagasy', nativeName: 'Malagasy', rtl: false },
  { code: 'mk', name: 'Macedonian', nativeName: 'Македонски', rtl: false },
  { code: 'ml', name: 'Malayalam', nativeName: 'മലയാളം', rtl: false },
  { code: 'mn', name: 'Mongolian', nativeName: 'Монгол', rtl: false },
  { code: 'mr', name: 'Marathi', nativeName: 'मराठी', rtl: false },
  { code: 'ms', name: 'Malay', nativeName: 'Bahasa Melayu', rtl: false },
  { code: 'mt', name: 'Maltese', nativeName: 'Malti', rtl: false },
  { code: 'my', name: 'Burmese', nativeName: 'မြန်မာဘာသာ', rtl: false },
  { code: 'nb', name: 'Norwegian (Bokmål)', nativeName: 'Norsk bokmål', rtl: false },
  { code: 'ne', name: 'Nepali', nativeName: 'नेपाली', rtl: false },
  { code: 'nl', name: 'Dutch', nativeName: 'Nederlands', rtl: false },
  { code: 'nn', name: 'Norwegian (Nynorsk)', nativeName: 'Norsk nynorsk', rtl: false },
  { code: 'or', name: 'Odia', nativeName: 'ଓଡ଼ିଆ', rtl: false },
  { code: 'pa', name: 'Punjabi', nativeName: 'ਪੰਜਾਬੀ', rtl: false },
  { code: 'pl', name: 'Polish', nativeName: 'Polski', rtl: false },
  { code: 'ps', name: 'Pashto', nativeName: 'پښتو', rtl: true },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português', rtl: false },
  { code: 'pt-BR', name: 'Portuguese (Brazil)', nativeName: 'Português (Brasil)', rtl: false },
  { code: 'ro', name: 'Romanian', nativeName: 'Română', rtl: false },
  { code: 'ru', name: 'Russian', nativeName: 'Русский', rtl: false },
  { code: 'rw', name: 'Kinyarwanda', nativeName: 'Ikinyarwanda', rtl: false },
  { code: 'si', name: 'Sinhala', nativeName: 'සිංහල', rtl: false },
  { code: 'sk', name: 'Slovak', nativeName: 'Slovenčina', rtl: false },
  { code: 'sl', name: 'Slovenian', nativeName: 'Slovenščina', rtl: false },
  { code: 'so', name: 'Somali', nativeName: 'Soomaali', rtl: false },
  { code: 'sq', name: 'Albanian', nativeName: 'Shqip', rtl: false },
  { code: 'sr', name: 'Serbian', nativeName: 'Српски', rtl: false },
  { code: 'sv', name: 'Swedish', nativeName: 'Svenska', rtl: false },
  { code: 'sw', name: 'Swahili', nativeName: 'Kiswahili', rtl: false },
  { code: 'ta', name: 'Tamil', nativeName: 'தமிழ்', rtl: false },
  { code: 'te', name: 'Telugu', nativeName: 'తెలుగు', rtl: false },
  { code: 'tg', name: 'Tajik', nativeName: 'Тоҷикӣ', rtl: false },
  { code: 'th', name: 'Thai', nativeName: 'ไทย', rtl: false },
  { code: 'tl', name: 'Filipino', nativeName: 'Filipino', rtl: false },
  { code: 'tr', name: 'Turkish', nativeName: 'Türkçe', rtl: false },
  { code: 'uk', name: 'Ukrainian', nativeName: 'Українська', rtl: false },
  { code: 'ur', name: 'Urdu', nativeName: 'اردو', rtl: true },
  { code: 'uz', name: 'Uzbek', nativeName: 'Oʻzbek', rtl: false },
  { code: 'vi', name: 'Vietnamese', nativeName: 'Tiếng Việt', rtl: false },
  { code: 'yo', name: 'Yoruba', nativeName: 'Yorùbá', rtl: false },
  { code: 'zh-CN', name: 'Chinese (Simplified)', nativeName: '简体中文', rtl: false },
  { code: 'zh-TW', name: 'Chinese (Traditional)', nativeName: '繁體中文', rtl: false },
  { code: 'zh-HK', name: 'Chinese (Hong Kong)', nativeName: '繁體中文（香港）', rtl: false },
  { code: 'zu', name: 'Zulu', nativeName: 'isiZulu', rtl: false },
];

// Derived exports
export const localeCodes: string[] = LOCALES.map(l => l.code);

export const localeMap: Record<string, LocaleEntry> = Object.fromEntries(
  LOCALES.map(l => [l.code, l])
);

export const localeNames: Record<string, string> = Object.fromEntries(
  LOCALES.map(l => [l.code, l.nativeName])
);

export const rtlLocales: readonly string[] = LOCALES.filter(l => l.rtl).map(l => l.code);
const RTL_CODES = new Set(rtlLocales);

export function isRtlLocale(locale: string): boolean {
  return RTL_CODES.has(locale);
}

export const defaultLocale = 'en';

export type Locale = string;
